<template>
    <div class="dialog draggable-item bg-light light center text-small rounded w-100-sm w-100-md w-75-lg w-50-xl" v-cloak>

        <DialogTitle :title="serviceAccount.id == null ? $t('Add Service Account') : serviceAccount.name"
            :defaultTitle="serviceAccount.id == null ? $t('Add Service Account') : $t('Edit/Test Service Account')"
            :subTitle="serviceAccount.type_name" @closeDialog="$root.$emit('CLOSESERVICEACCOUNTDIALOG')" />

        <div class="dialog-content overflow bg-light">

            <!--------------------------FORM--------------------------------------------->
            <div class="form-group">
                <label>{{ $t("Name") }}*</label>
                <input data-role="input" type="text" v-model="serviceAccount.name" maxlength="50"
                    :placeholder="$t('enter name')" data-prepend="<span class='mif-pencil'></span>" />
                
            </div>
            <div class="form-group">
                <label>{{ $t("Username") }}*</label>
                <input data-role="input" type="text" v-model.trim="serviceAccount.username" v-no-autocomplete="'mif-person'" />
            </div>
            <div class="form-group">
                <label>{{ $t("Password") }}*</label>
                <input v-if="[null, ''].includes(serviceAccount.id)" class="metro-input" data-role="input" type="password" v-model.trim="serviceAccount.password" :placeholder="$t('Enter Password')" v-no-autocomplete="'mif-lock'" />
                <input v-else class="metro-input" data-role="input" type="password" data-reveal-button="false" data-prepend="<span class='mif-lock'></span>" value="**********" disabled/>
            </div>
            <div class="form-group">
                <label>{{ $t("Path") }}*</label>
                <input data-role="input" type="text" data-validate="required" v-model="serviceAccount.options.path" v-path="this.$ONEServiceType.Network">
                
            </div>

            <!-------------------------------SCELTA PC----------------------------------------->
            <div v-if="$session.getRoomPC() == null" class="form-group">

                <SelectPCByGroup @selectPC="(pc) => { testPC = pc }" 
                    :groupLabel="$t('Select the group to which the endpoint should belong to test the {0} connection', { 0: $ONEServiceTypeInfo[serviceAccount.type].name })" 
                    :pcLabel="$t('Select an endpoint from which test the {0} connection', { 0: $ONEServiceTypeInfo[serviceAccount.type].name })" 
                    :showSATestMsg="true" :idPC="serviceAccount.options.lastTestPC" :selectIfOnline="true"
                />

            </div>
        </div>

        <!-------------------------------TEST ACCOUNT----------------------------------------->
        <div class="dialog-actions">
            <ClientMessageView :commands="['testserviceaccount']" ref="CM_SA"/>
            <div v-if="tested == $ResultValue.Running"><span class="mif-spinner2 ani-spin" /></div>
            <button class="button bg-amber" @click="test" :disabled="!enableTest" v-disable-tooltip:disabledTest_message> {{ $t("Test account") }}</button>
            <button class="button secondary" :disabled="!enableSave" v-disable-tooltip="$t('You can save the account only if the account test is successful.')" @click="saveServiceAccount(serviceAccount)"> {{ $t("Save") }}</button>
        </div>
    </div>
</template>

<script>
import DialogTitle from "../../utils/DialogTitle.vue";
import { isValid, waitSeconds } from "../../../utils/utilitiesmodule";

import { draggableMixin } from '../../../mixins/draggable-mixin';
import SelectPCByGroup from "../../utils/SelectPCByGroup.vue";
import ClientMessageView from "../view/ClientMessageView.vue";
import { ClientMessage } from "../../../utils/objects";
import { disconnectServiceAccount, saveServiceAccount, testServiceAccount } from "../../../utils/entityMethods/serviceAccount";


export default {

    mixins: [draggableMixin],
    name: "NetworkServiceAccount",
    components: {
        "DialogTitle": DialogTitle,
        SelectPCByGroup,
        ClientMessageView
    },
    props: {
        serviceAccount: Object,
    },
    data() {
        return {
            testPC: null,

            tested: this.$ResultValue.NeverExecuted,
            disabledTest_message: ""
        }
    },

    async beforeDestroy() {
        this.$root.$off("socketEventConnected");
        this.$root.$off("socketEventDisconnected");
        if (isValid(this.serviceAccount.options.accountSessionId)) {
            this.disconnectServiceAccount(this.serviceAccount);
        }

    },
    computed: {
        allInputCompleted() {
            return this.serviceAccount.name!=""&&(this.$session.getRoomPC()!=null||this.testPC!=null)&&
                this.serviceAccount.username!=""&&
                this.serviceAccount.password!=""&&
                this.serviceAccount.options.path!=""&&
                this.serviceAccount.options.path.startsWith("\\\\")&&
                this.serviceAccount.options.path.lastIndexOf("\\")>1;
        },
        enableTest() {
            if (!this.allInputCompleted) {
                this.disabledTest_message=this.$t('Edit connection credentials before testing the account.');
                this.setClientMessage(ClientMessage.info_translated(this.disabledTest_message));
                return false;
            }

            switch (this.tested) {

                case this.$ResultValue.NeverExecuted:
                    if (this.serviceAccount.id!=null) {
                        this.setClientMessage(null);
                    } else {
                        this.setClientMessage(ClientMessage.info_translated(this.$t('You can save the account only if the account test is successful.')));
                    }
                    return true;

                case this.$ResultValue.Running:
                    this.disabledTest_message="";
                    return false;

                case this.$ResultValue.OK:
                    this.disabledTest_message=this.$t("Service account already validated");
                    return false;
                case this.$ResultValue.Error:

                    if (this.serviceAccount.id==null) {
                        this.disabledTest_message=this.$t("You can save the account only if the account test is successful.");
                    } else {
                        this.disabledTest_message="";
                    }

                    return true;
            }
        },
        enableSave() {
            return this.allInputCompleted&&(this.tested==this.$ResultValue.OK||this.tested==this.$ResultValue.Error&&this.serviceAccount.id!=null);
        }

    },
    created() {
        if (this.serviceAccount.options.lastTestPC!=null) {
            this.testPC=this.$session.getPCWithID(this.serviceAccount.options.lastTestPC);
        }

        if (this.serviceAccount.options.path==undefined) {
            this.serviceAccount.options.path="\\\\";
        }
    },
    methods: {
        disconnectServiceAccount,
        saveServiceAccount,
        testServiceAccount,

        async test() {

            this.tested=this.$ResultValue.Running; // test in corso
            var testResult=await this.testServiceAccount(this.serviceAccount, this.testPC);
            this.tested=testResult.ok? this.$ResultValue.OK:this.$ResultValue.Error;
            if (testResult.ok) {
                this.serviceAccount.options.accountSessionId=testResult.serviceAccount.options.accountSessionId;
                this.serviceAccount.options.lastTestPC=testResult.serviceAccount.options.lastTestPC;
            }

        },
        setClientMessage(clientMessage) {
            if (this.$refs.CM_SA) {
                this.$refs.CM_SA.setClientMessage(clientMessage);
            } else {
                waitSeconds(0.2).then(_ => {
                    this.$refs.CM_SA.setClientMessage(clientMessage);
                });
            }
        }

        /**************************SALVATAGGIO SERVICE ACCOUNT********************************/
    },
}

</script>
